import type { SVGProps } from 'react';

const SvgRankingThree = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={32}
    viewBox='0 0 32 32'
    width={32}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M24 27.333h-1.333V27c0-1.467-1.2-2.667-2.667-2.667h-3V21.28c-.333.04-.667.053-1 .053s-.667-.013-1-.053v3.053h-3A2.674 2.674 0 0 0 9.333 27v.333H8c-.547 0-1 .454-1 1 0 .547.453 1 1 1h16c.547 0 1-.453 1-1s-.453-1-1-1'
      fill='#895E33'
    />
    <path
      d='M7.36 15.52c-.88-.333-1.653-.88-2.267-1.493-1.24-1.374-2.053-3.014-2.053-4.934a3.39 3.39 0 0 1 3.427-3.426h.746A5.3 5.3 0 0 0 6.667 8v4c0 1.253.24 2.44.693 3.52M28.96 9.093c0 1.92-.814 3.56-2.054 4.934-.613.613-1.386 1.16-2.266 1.493a9.1 9.1 0 0 0 .693-3.52V8c0-.84-.2-1.627-.547-2.333h.747a3.39 3.39 0 0 1 3.427 3.426'
      fill='#956C48'
    />
    <path
      d='M20 2.667h-8A5.33 5.33 0 0 0 6.667 8v4A9.327 9.327 0 0 0 16 21.333 9.327 9.327 0 0 0 25.333 12V8A5.33 5.33 0 0 0 20 2.667'
      fill='#B08961'
    />
    <g filter='url(#ranking-three)'>
      <path
        d='M15.979 16a3.8 3.8 0 0 1-1.517-.29 2.6 2.6 0 0 1-1.053-.818 2.07 2.07 0 0 1-.398-1.193h1.634q.015.285.194.505.177.22.478.344.3.12.672.119.382 0 .683-.135.306-.14.473-.382a.9.9 0 0 0 .167-.548.9.9 0 0 0-.178-.564 1.13 1.13 0 0 0-.51-.382 2 2 0 0 0-.785-.14h-.72v-1.193h.72q.376 0 .672-.13.295-.128.462-.365a.9.9 0 0 0 .167-.538.94.94 0 0 0-.543-.87A1.3 1.3 0 0 0 16 9.29q-.344 0-.634.124-.285.119-.463.344a.86.86 0 0 0-.183.51h-1.548q.01-.66.382-1.177a2.43 2.43 0 0 1 1.01-.8Q15.21 8 16 8q.795 0 1.409.29.617.285.957.79.338.5.333 1.114a1.56 1.56 0 0 1-.704 1.344q-.334.225-.77.3v.065a2.4 2.4 0 0 1 .963.312q.398.241.602.63.205.38.2.865a1.92 1.92 0 0 1-.382 1.182q-.388.522-1.076.818-.689.29-1.553.29'
        fill='#fff'
      />
    </g>
    <defs>
      <filter
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
        height={13.333}
        id='ranking-three'
        width={11.312}
        x={10.344}
        y={5.333}
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1.333} />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0.537255 0 0 0 0 0.368627 0 0 0 0 0.2 0 0 0 1 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_1192_75053' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow_1192_75053' result='shape' />
      </filter>
    </defs>
  </svg>
);
export default SvgRankingThree;
